import { ContentState, Modifier, SelectionState } from 'draft-js'

export const BLOCK_KEY = 'main_block-v2'

export const getSelectionState = (start: number, end: number): SelectionState => {
  return new SelectionState({
    anchorKey: BLOCK_KEY,
    anchorOffset: start,
    focusKey: BLOCK_KEY,
    focusOffset: end,
  })
}

export const removeEntity = (
  contentState: ContentState,
  selection: SelectionState
): ContentState => {
  return Modifier.applyEntity(contentState, selection, null)
}

export const updateEntity = (
  contentState: ContentState,
  selection: SelectionState,
  entityKey: string
): ContentState => Modifier.applyEntity(contentState, selection, entityKey)



// WEBPACK FOOTER //
// ./src/state/document/document.helper.ts